import React from "react";

const renderOptions = (cartItem) => {
  if (cartItem.selectedVariants) {
    return (
      <div className="cart-item-variation">
        <span>
          {cartItem.selectedVariants.colorSelected.value && cartItem.selectedVariants.colorSelected.value !== "" &&
          cartItem.selectedVariants.colorSelected.value !== undefined
            ? `Color seleccionado: ${cartItem.selectedVariants.colorSelected.value}`
            : ""}
        </span>
        <span>
          {cartItem.selectedVariants.designSelected && cartItem.selectedVariants.designSelected.value !== "" &&
          cartItem.selectedVariants.designSelected.value !== undefined
            ? `Diseño seleccionado: ${cartItem.selectedVariants.designSelected.value}`
            : ""}
        </span>
        <span>
          {cartItem.selectedVariants.sizeSelected&& cartItem.selectedVariants.sizeSelected.value !== "" &&
          cartItem.selectedVariants.sizeSelected.value !== undefined
            ? `Tamaño seleccionado: ${cartItem.selectedVariants.sizeSelected.value}`
            : ""}
        </span>
        <span>
          {cartItem.selectedVariants.optionNeutralSelected && cartItem.selectedVariants.optionNeutralSelected.value !== "" &&
          cartItem.selectedVariants.optionNeutralSelected.value !== undefined
            ? `Opción: ${cartItem.selectedVariants.optionNeutralSelected.value}`
            : ""}
        </span>
      </div>
    );
  }
  return <></>;
};

export default renderOptions;
